export default "__VITE_ASSET__b606b8ff__"